import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import CirclesDropdown from './CirclesDropdown';
import SingleCircle from './SingleCircle';
import {ORMCircles} from '../../app/models/ormSelectors';
import {generateInviteLink, selectPseudoPhone} from '../onboarding/onboardingSlice';
import {selectToken} from '../auth/authSlice';


const Circles = () => {
    const dispatch = useDispatch();
    const ormCircles = useSelector(ORMCircles);
    const phone = useSelector(selectPseudoPhone);
    const token = useSelector(selectToken);
    const showCircleInfo = false; // hide circle info

    useEffect(() => {
        if (phone && token) {
            dispatch(generateInviteLink(token, ormCircles[0].id, phone))
        }
    }, [phone, token])


    if (showCircleInfo && ormCircles.length === 1) {
        return <SingleCircle name={ormCircles[0].name} id={ormCircles[0].pin}/>
    }

    return <CirclesDropdown/>
};

export default Circles;